<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiBellOutline } from "@mdi/js";
export default {
  name: "MdiBellOutline",
  data() {
    return {
      svgPath: mdiBellOutline,
    };
  },
};
</script>
